export const LOCALE_COOKIE_NAME = 'gatsby-intl-language';

export function parseCookieHeader(cookieHeader = '') {
	return cookieHeader
		.split(';')
		.map((pair) => pair.trim())
		.filter(Boolean)
		.reduce((cookies, pair) => {
			const index = pair.indexOf('=');
			if (index === -1) return cookies;
			const key = decodeURIComponent(pair.slice(0, index).trim());
			const value = decodeURIComponent(pair.slice(index + 1).trim());
			cookies[key] = value;
			return cookies;
		}, {});
}

function matchFromAcceptLanguage(acceptLanguageHeader, supportedLanguages) {
	if (!acceptLanguageHeader) return null;

	const tags = acceptLanguageHeader
		.split(',')
		.map((part) => part.trim().split(';')[0])
		.filter(Boolean);

	for (const tag of tags) {
		const normalized = tag.toLowerCase().replace('_', '-');
		const short = normalized.split('-')[0];

		const exact = supportedLanguages.find((lang) => lang.toLowerCase() === normalized);
		if (exact) return exact;

		const partial = supportedLanguages.find((lang) => lang.toLowerCase() === short);
		if (partial) return partial;
	}

	return null;
}

export function detectPreferredLocale({ cookieHeader, acceptLanguageHeader, supportedLanguages, fallback }) {
	const cookies = parseCookieHeader(cookieHeader);
	const cookieLocale = cookies[LOCALE_COOKIE_NAME];

	if (cookieLocale && supportedLanguages.includes(cookieLocale)) {
		return cookieLocale;
	}

	const matched = matchFromAcceptLanguage(acceptLanguageHeader, supportedLanguages);
	return matched || fallback;
}
